import { render, staticRenderFns } from "./fcInfomation.vue?vue&type=template&id=d6a41fe4"
import script from "./fcInfomation.vue?vue&type=script&lang=js"
export * from "./fcInfomation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports